export default {
      id: "MD-usage",
      viewBox: "0 0 15 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#MD",
      toString: function () {
        return this.url;
      }
    }